// namespace
export const STORE_NAMESPACE = 'tags'

// actions
export const FETCH_ALL = 'fetchAll'

// mutations
export const SET_TAG_LIST = 'SET_TAG_LIST'

// getters
